import { render } from "./starRating.vue?vue&type=template&id=32e3e09e"
import script from "./starRating.vue?vue&type=script&lang=js"
export * from "./starRating.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__